module.exports = __webpack_public_path__ + "assets/70ac6679-cf48-4a0e-a909-d1e3bb4a1aa9.120c5874.svg";